import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import SharedTextButton from '../sharedTextButton/sharedTextButton'
import * as styles from './status.module.scss'
import moment from "moment"
import { orderBy } from "lodash"
import ReactMarkdown from "react-markdown"

export default ({ block }) => {
  const {
    allServiceComponentStatusesJson: { nodes: componentStatuses }
    } = useStaticQuery(graphql`
    {
      allServiceComponentStatusesJson {
        nodes {
          title
          color
        }
      }
    }`)

  const maintenanceItems = block.maintenanceItems ?? []
  const outages = block.outages ?? []

  const isUnderMaintenance = (component) => {
    const now = moment().valueOf()
    return !!maintenanceItems.find(m =>
      m.components && m.components.some(c => c.serviceComponent === component.serviceComponent) &&
      now >= moment(m.startTime).valueOf() &&
      now <= moment(m.startTime)
        .add(m.hours, 'hours')
        .add(m.minutes, 'minutes')
        .valueOf()
    )
  }

  const getOutage = (component) => {
    return outages.find(o =>
      o.components.some(c => c.serviceComponent === component.serviceComponent))
  }

  const getOutageColor = (o) => {
    if (o.serviceIncidentStatus === 'Resolved') {
      return componentStatuses.find(s => s.title === 'Operational')?.color ?? '#074786'
    }

    return componentStatuses.find(s => s.title === o.serviceComponentStatus)?.color ?? '#074786'
  }

  const getComponentOutageColor = (o) => {
    return o.serviceIncidentStatus === 'Resolved'
      ? componentStatuses.find(s => s.title === 'Operational')?.color ?? '#074786'
      : getOutageColor(o)
  }

  const getStatus = (c) => {
    const outage = getOutage(c)

    return outage && outage.serviceIncidentStatus !== 'Resolved'
      ? outage.serviceComponentStatus
      : 'Operational'
  }

  const maintenanceColor = componentStatuses.find(s => s.title ===   'Maintenance')?.color ?? '#074786'

  const getColor = (c) => {
    const outage = getOutage(c)

    return isUnderMaintenance(c)
      ? maintenanceColor
      : outage
      ? getComponentOutageColor(outage) ?? '#074786'
      : componentStatuses.find(s => s.title === 'Operational')?.color ?? '#074786'
  }

  const getUpdates = (updates) => {
    const updatesWithIndexes =  orderBy(updates, u => moment(u.time).valueOf())
      .map((u,i) => ({...u, index: i + 1 }))

    return orderBy(updatesWithIndexes, u => u.index, 'desc')
  }

  const now = moment().valueOf()
  
  const maintenance = orderBy(maintenanceItems, m => moment(m.startTime).valueOf(), 'desc')

  return <section className={styles.section}>
    <div className={styles.container}>
      <h1>{block.blockTitle}</h1>
      <p className={styles.description}>{block.description}</p>
      <div className={styles.formButton}>
        <SharedTextButton button={block.sharedTextButton} />
      </div>

      <div className={styles.components}>
        {block.components.map((c,i) => (
          <div key={i}>
            <span>{c.serviceComponent}</span>
            <span
              style={{ color: getColor(c)}}
            >{
              isUnderMaintenance(c) ? 'Under Maintenance' : getStatus(c)
            }</span>
          </div>
        ))}
      </div>

      {outages && outages.length > 0 && <div className={styles.outages}>
        {outages.map((o,i) => (
          <div key={i} className={styles.outage} style={{ borderColor: getOutageColor(o)}}>
            <h3
              style={{ backgroundColor: getOutageColor(o)}}
            >{o.outageTitle} <span className={styles.divider}>|</span><br className={styles.linebreak}></br>&nbsp;Status: <strong>{o.serviceIncidentStatus}</strong></h3>
            {getUpdates(o.updates).map((u,ui) => (
              <div key={ui} className={styles.outageUpdate}>
                <ReactMarkdown>{`**Update ${u.index}** - ` + u.message}</ReactMarkdown>
                <span className={styles.time}>{moment(u.time).format('MMM DD, YYYY HH:mm')} CDT</span>
                {ui != o.updates.length - 1 && 
                  <hr></hr>
                }
              </div>
            ))}
          </div>
        ))}
      </div>}

      {maintenance && maintenance.length > 0 && <div className={styles.maintenance}
        style={{ borderColor: maintenanceColor }}
      >
        <h3
          className={styles.maintenanceTitle}
          style={{ backgroundColor: maintenanceColor }}
        >{block.maintenanceTitle ?? 'Maintenance'}</h3>
        {maintenance.map((m,i) => (
          <div key={i} className={styles.maintenanceItem}
            style={{ borderColor: maintenanceColor }}
          >
            <h3>{m.title}</h3>
            <div className={styles.timeframe}>
              <span>{moment(m.startTime).format('MMM DD, YYYY HH:mm')}</span>
              &nbsp;-&nbsp;
              <span>{moment(m.startTime)
                .add(m.hours, 'hours')
                .add(m.minutes, 'minutes')
                .format('MMM DD, YYYY HH:mm')} CDT
              </span>
            </div>
            <ReactMarkdown className={styles.message}>{m.message}</ReactMarkdown>
          </div>
        ))}
      </div>}
    </div>
    
  </section>
}
